module.exports = __webpack_public_path__ + "img/pvc-image.d17302f6.png";